import { twMerge } from "tailwind-merge";
import Text from "../../components/Text";
import Heading from "../Heading";

interface ISection {
  title?: string | React.ReactNode;
  isTranslucent?: boolean;
  className?: string;
  children?: React.ReactNode;
  titleInside?: boolean;
}

function Section({ title, className, isTranslucent = true, children, titleInside }: ISection) {
  return (
    <section className={twMerge('flex flex-col not:last:mb-8 last:mb-4 [&:not(:last-of-type)]:mb-8')}>
      {title && !titleInside && <Heading as="h3" className="mb-2">{title}</Heading>}
      <div className={twMerge(
        isTranslucent ? "bg-darkglass" : "", 
        titleInside ? "py-6 rounded-2xl" : "p-4 rounded-xl", 
        className
      )}>
        {title && titleInside && <h4 className="mb-2 pl-6">{title}</h4>}
        {children}
      </div>
    </section>
  );
}

export default Section;
